var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66071 0.764648H21.3393C22.3744 0.764648 23.25 1.64706 23.25 2.77935V21.2205C23.25 22.3528 22.3744 23.2352 21.3393 23.2352H3.66071C2.62563 23.2352 1.75 22.3528 1.75 21.2205V2.77935C1.75 1.64706 2.62563 0.764648 3.66071 0.764648Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80418 15.75L12.4464 7.82336H10.6611L8.89231 13.8823H8.79343L6.99168 7.82336H5.11851L7.79917 15.75H9.80418Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2787 13.5472C13.3391 15.0249 14.5641 15.9532 16.4538 15.9532C18.4423 15.9532 19.6673 14.9755 19.6673 13.377C19.6673 12.1465 18.9806 11.4598 17.3876 11.1248L16.4318 10.9215C15.5034 10.7238 15.1244 10.4436 15.1244 9.95471C15.1244 9.35046 15.6737 8.96594 16.5032 8.96594C17.3052 8.96594 17.8875 9.38342 17.9644 10.0096H19.5244C19.475 8.5979 18.239 7.62012 16.4922 7.62012C14.663 7.62012 13.46 8.60339 13.46 10.0975C13.46 11.306 14.1686 12.0586 15.6133 12.3607L16.646 12.5804C17.6183 12.7892 18.0138 13.0803 18.0138 13.5857C18.0138 14.1844 17.4041 14.6019 16.5416 14.6019C15.6078 14.6019 14.9596 14.1899 14.8827 13.5472H13.2787Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/vs.affc42cc463e649a272dc156fa570f82.svg";
export { ForwardRef as ReactComponent };